import React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { routes } from "../api/paths";

export interface GuardedRouteProps extends RouteProps {
  userRole: string;
  requiredRole: string;
}

export const GuardedRoute: React.FC<GuardedRouteProps> = (
  props: GuardedRouteProps
) => {
  const { userRole, requiredRole } = props;

  if (userRole === requiredRole || userRole === "SUPER_ADMIN") {
    return <Route {...props} />;
  } else {
    const renderComponent = () => <Redirect to={routes.LOGIN_URL} />;
    return <Route {...props} component={renderComponent} render={undefined} />;
  }
};

export default GuardedRoute;
